import './DashboardItem.sass';

import { FC, MouseEvent, useCallback, useMemo } from 'react';

import { DashboardItemProps } from './DashboardItem.interface';
import {
  IcContest28,
  IcDollar28,
  IcMessage28,
  IcPickaxe28,
  IcStar28,
  IcSuccessCheck28,
  IcUser28,
} from '$assets';
import { showModal } from '$navigation/helper';
import { useDispatch } from 'react-redux';
import { dashboardActions } from '$store/dashboard';
import { classNames as cn, statReachGoal } from '$utils';
import { useTranslator } from '$hooks';

const Icons = {
  profile: IcUser28,
  sponsors: IcStar28,
  messages: IcMessage28,
  contest: IcContest28,
  sale: IcDollar28,
  pickaxe: IcPickaxe28,
};

export const DashboardItem: FC<DashboardItemProps> = (props) => {
  const { task, section } = props;
  const dispatch = useDispatch();
  const Icon = Icons[section.icon];
  const t = useTranslator();

  const handleClick = useCallback(() => {
    showModal(`task_${task.id}`);
  }, [task]);

  const handleComplete = useCallback(
    (e: MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
      dispatch(dashboardActions.completeTask(task));
    },
    [task.id],
  );

  const value = useMemo(() => {
    return (task.currentValue / task.finalValue) * 100;
  }, [task]);

  return (
    <div className="DashboardItem" onClick={handleClick}>
      <div className="DashboardItem__body">
        <div className="DashboardItem__icon">
          {value >= 100 ? <IcSuccessCheck28 /> : !!Icon && <Icon />}
        </div>
        <div className="DashboardItem__cont">
          <div className="DashboardItem__firstRow">
            <div className="DashboardItem__section">{section.name}</div>
            {!!task.reward && (
              <div className="DashboardItem__reward">
                <div>+{task.reward}€</div>
              </div>
            )}
          </div>
          <div className="DashboardItem__secondRow">
            <div className="DashboardItem__title">{task.title}</div>
            {!!task.finalValue && (
              <div className="DashboardItem__progressLabel">
                {task.currentValue || 0}/{task.finalValue || 0}
              </div>
            )}
          </div>
          {!!task.finalValue && (
            <div className="DashboardItem__progressBar">
              <div
                className={cn('DashboardItem__progressBar__value', {
                  filled: value >= 100,
                })}
                style={{ width: value + '%' }}
              />
            </div>
          )}
        </div>
      </div>
      {/*<div className="DashboardItem__chevron">*/}
      {/*  <IcAngleRight16 />*/}
      {/*</div>*/}
      {task.isReached && !task.isCompleted && (
        <div className="DashboardItem__button" onClick={handleComplete}>
          {t('task_button_complete')}
        </div>
      )}
    </div>
  );
};
